var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"game-iframe",style:({ 'height': _vm.getHeight }),attrs:{"allowfullscreen":"","scrolling":"no","id":"iframe","src":_vm.getPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }